import { AnimatePresence, motion } from "framer-motion";

const Pager = ({ step, stepCount }) => {
  const animationConfiguration = {
    initial: { width: "0%", x: 0, opacity: 1 },
    animate: { width: `calc(100% / ${stepCount / step})`, x: 0, opacity: 1 },
    exit: { x: "-20%", opacity: 0, transition: { duration: 0.2 } },
  };

  return (
    <div className="text-right">
      <hr className="border-1  border-accent-secondary dark:border-accent-dark" />

      <motion.hr
        key={stepCount}
        variants={animationConfiguration}
        initial="initial"
        animate="animate"
        exit="exit"
        transition={{ delay: 0, duration: 0.2 }}
        className="border-2  border-accent  -mt-0.5"
        style={{ width: `calc(100% / ${stepCount / step})` }}
      ></motion.hr>
      <p className="mt-2 text-sm font-light text-secondary">
        Krok {step}/{stepCount}
      </p>
    </div>
  );
};

export default Pager;
